import { ISupplierTax } from '../../types/entities/ISupplierTax';
import { ITaxState } from '../../types/taxes/taxesTypes';
import { convertDateToUTC, isMinValueDate } from '../../utils/formatDates';

export const adaptTaxFromDDBB = (tax: ISupplierTax): ITaxState => {
    return {
        Id: tax.Id,
        Amount: tax.Amount,
        Enabled: tax.Enabled,
        Name: tax.Name,
        Description: tax.Description,
        IdSupplierHotel: tax.IdSupplierHotel,
        SupplierHotel: tax.SupplierHotel?.Name || '',
        IdSupplierHotelRoomType: tax.IdSupplierHotelRoomType,
        SupplierHotelRoomType: tax.SupplierHotelRoomType?.Name || '',
        IdSupplierHotelMealPlan: tax.IdSupplierHotelMealPlan,
        SupplierHotelMealPlan: tax.SupplierHotelMealPlan?.Name || '',
        IdSupplierHotelRatePlan: tax.IdSupplierHotelRatePlan,
        SupplierHotelRatePlan: tax.SupplierHotelRatePlan?.Name || '',
        IdSupplierTaxType: tax.IdSupplierTaxType,
        SupplierTaxType:
            tax.SupplierTaxType?.Caption || tax.SupplierTaxType?.Name || '',
        SupplierTaxTypeKey: tax.SupplierTaxType?.Key || '',
        IdSupplierTaxCalculationType: tax.IdSupplierTaxCalculationType,
        SupplierTaxCalculationType:
            tax.SupplierTaxCalculationType?.LocalizedCaption ||
            tax.SupplierTaxCalculationType?.Caption ||
            tax.SupplierTaxCalculationType?.Name ||
            '',
        SupplierTaxCalculationTypeKey:
            tax.SupplierTaxCalculationType?.Key || '',
        IdSupplierTaxCalculationRuleType: tax.IdSupplierTaxCalculationRuleType,
        SupplierTaxCalculationRuleType:
            tax.SupplierTaxCalculationRuleType?.LocalizedCaption ||
            tax.SupplierTaxCalculationRuleType?.Caption ||
            tax.SupplierTaxCalculationRuleType?.Name ||
            '',
        SupplierTaxCalculationRuleTypeKey:
            tax.SupplierTaxCalculationRuleType?.Key || '',
        IdSupplementCalculationType: tax.IdSupplementCalculationType,
        SupplementCalculationType:
            tax.SupplementCalculationType?.LocalizedCaption ||
            tax.SupplementCalculationType?.Caption ||
            tax.SupplementCalculationType?.Name ||
            '',
        SupplementCalculationTypeKey: tax.SupplementCalculationType?.Key || '',
        Priority: tax.Priority,
        IdCurrency: tax.IdCurrency,
        Currency: tax.Currency.Name,
        EffectivePerson: tax.EffectivePerson,
        FromAge: tax.FromAge,
        ToAge: tax.ToAge,
        OnlyAdults: tax.OnlyAdults,
        OnlyChildren: tax.OnlyChildren,
        FromDate: isMinValueDate(tax.FromDate) ? null : tax.FromDate,
        ToDate: isMinValueDate(tax.ToDate) ? null : tax.ToDate,
        LastUpdate: tax.DateLastUpdated,
    };
};

export const adaptTaxToDDBB = (tax: ITaxState) => {
    return {
        Id: tax.Id,
        Amount: tax.Amount,
        Enabled: tax.Enabled,
        Name: tax.Name,
        Description: tax.Description,
        IdSupplierHotel: tax.IdSupplierHotel,
        IdSupplierHotelRoomType: tax.IdSupplierHotelRoomType,
        IdSupplierHotelMealPlan: tax.IdSupplierHotelMealPlan,
        IdSupplierHotelRatePlan: tax.IdSupplierHotelRatePlan,
        IdSupplierTaxType: tax.IdSupplierTaxType,
        IdSupplierTaxCalculationType: tax.IdSupplierTaxCalculationType,
        IdSupplierTaxCalculationRuleType: tax.IdSupplierTaxCalculationRuleType,
        IdSupplementCalculationType: tax.IdSupplementCalculationType,
        Priority: tax.Priority,
        IdCurrency: tax.IdCurrency,
        EffectivePerson: tax.EffectivePerson,
        FromAge: tax.FromAge,
        ToAge: tax.ToAge,
        OnlyAdults: tax.OnlyAdults,
        OnlyChildren: tax.OnlyChildren,
        FromDate: tax.FromDate ? convertDateToUTC(tax.FromDate) : null,
        ToDate: tax.ToDate ? convertDateToUTC(tax.ToDate) : null,
    };
};
